import React, {useCallback, useEffect} from 'react';
import {AlertDanger} from '@homeaway/react-alerts';
import translate from '../../../utils/translations';

import './ErrorMessages.less';
import {
    errorAlertClosed,
    errorPresented,
    TRIP_DETAILS,
} from '../../../utils/edapUtils';

const messages = {
    WEATHER_PROMISE: {
        title: 'insurtech.weatherPromise.error.title',
        message: 'insurtech.weatherPromise.error.message',
    },
};

const mapErrorMessages = (failedItems, translations) => {
    const errors = [];

    if (!failedItems) {
        return null;
    }

    const translateField = (record, type) =>
        translate(
            translations,
            'ui-development/shared',
            'errorMessages',
            record?.[type]
        );

    failedItems.forEach((item) => {
        const record = messages[item.vasPaymentDetails?.type];

        if (record) {
            errors.push({
                title: translateField(record, 'title'),
                message: translateField(record, 'message'),
                key: item.vasPaymentDetails?.type.toLowerCase(),
            });
        }
    });

    return errors;
};

const ErrorMessages = ({confirmation, translations}) => {
    const failedInsurtechItems =
        confirmation.priceDetails?.failedInsurtechItems;

    const genericErrors = mapErrorMessages(failedInsurtechItems, translations);

    useEffect(() => {
        if (failedInsurtechItems && genericErrors?.length > 0) {
            genericErrors.find((error) => {
                errorPresented({actionLocation: TRIP_DETAILS, key: error.key});
            });
        }
    }, []);

    const onAlertClosedHandler = useCallback((key) => {
        errorAlertClosed({actionLocation: TRIP_DETAILS, key});
    }, []);

    if (!genericErrors || genericErrors.length === 0) {
        return null;
    }

    return (
        <div className="generic-alert">
            {genericErrors.map((error) => (
                <AlertDanger
                    className={`global-error-alert`}
                    title={error.title}
                    dismissible
                    msg={
                        <span
                            dangerouslySetInnerHTML={{
                                __html: error.message,
                            }}
                        />
                    }
                    onAlertClosed={() => onAlertClosedHandler(error.key)}
                />
            ))}
        </div>
    );
};

export default ErrorMessages;
